export default __webpack_public_path__ + "static/media/bonus.0cc846da.webp";